import { Button, Stack, Typography, theme } from '@dtx-company/design-system/src'
import { FC } from 'react'
import { FooterAttachmentData } from '../types'
//sectionId is used for navigation
const FooterAttachmentSection: FC<{ data?: FooterAttachmentData; sectionId?: string }> = ({
  data,
  sectionId
}) => {
  if (!data) return null
  return (
    <Stack
      direction="column"
      alignItems="center"
      spacing={theme.spacing(10)}
      sx={{
        width: '100%',
        backgroundColor: '#0d0b24',
        padding: { xs: '48px 28px 20px 28px', md: '52px' }
      }}
      id={sectionId}
    >
      <Typography variant={{ xs: 'bodySmall', md: 'bodyLarge' }} color="white">
        {data.primary?.header}
      </Typography>
      {data.primary?.subheader && (
        <Stack
          direction="column"
          sx={{
            maxWidth: '604px',
            marginTop: theme.spacing(4)
          }}
          justifyContent="center"
        >
          <Typography variant="headlineSmall" color="white" textAlign="center">
            Used by over 10,000 businesses and 5 million individuals across
            <br /> 100+ countries with proven results.
          </Typography>
        </Stack>
      )}
      <Stack direction="row" alignItems="center">
        <Button
          data-heap-id="FooterAttachmentSection_CTAButton"
          href={data.primary?.button_href?.url}
          variant="contained"
          color="tertiary"
        >
          {data.primary?.button_label}
        </Button>
      </Stack>
    </Stack>
  )
}

export default FooterAttachmentSection
